import React, { useState, useEffect } from 'react'

import Swiper from 'react-id-swiper'

import Video from 'react-player'

import { AreaVideo } from '../../../Style/sobre/style'

import ArrowPrev from '../../../images/arrow-prev-slide-pessoas.svg'
import ArrowNext from '../../../images/arrow-next-slide-pessoas.svg'
import IconePlay from '../../../images/icone-play.svg'

const Gallery = () => {
  const [gallerySwiper, getGallerySwiper] = useState(null)
  const [thumbnailSwiper, getThumbnailSwiper] = useState(null)

  const goNext = () => {
    if (gallerySwiper !== null) {
      gallerySwiper.slideNext()
    }
  }
  const goPrev = () => {
    if (gallerySwiper !== null) {
      gallerySwiper.slidePrev()
    }
  }

  const gallerySwiperParams = {
    getSwiper: getGallerySwiper,
    preloadImages: false,
    spaceBetween: 10,
    pagination: {
      el: '.s-encontros .ctrl-slide .swiper-pagination',
      clickable: true,
    },
  }

  const thumbnailSwiperParams = {
    getSwiper: getThumbnailSwiper,
    preloadImages: false,
    spaceBetween: 23,
    touchRatio: 0.2,
    centeredSlides: true,
    slidesPerView: 'auto',
    slideToClickedSlide: true,
  }

  useEffect(() => {
    if (gallerySwiper !== null && gallerySwiper.controller && thumbnailSwiper !== null && thumbnailSwiper.controller) {
      gallerySwiper.controller.control = thumbnailSwiper
      thumbnailSwiper.controller.control = gallerySwiper
    }
  }, [gallerySwiper, thumbnailSwiper])

  return (
    <div className="area-slide">
      <div>
        <Swiper {...gallerySwiperParams}>
          <div className="swiper-slide">
            <AreaVideo>
              <Video className="video" url="https://www.youtube.com/watch?v=qx5hPRUdK3I" light playing />
            </AreaVideo>
          </div>
          <div className="swiper-slide">
            <AreaVideo>
              <Video className="video" url="https://www.youtube.com/watch?v=w5Bm3Cb1Cb8" light playing />
            </AreaVideo>
          </div>
          <div className="swiper-slide">
            <AreaVideo>
              <Video className="video" url="https://www.youtube.com/watch?v=y-FsYAKEfmQ" light playing />
            </AreaVideo>
          </div>
          <div className="swiper-slide">
            <AreaVideo>
              <Video className="video" url="https://www.youtube.com/watch?v=C6P8en0GQZA" light playing />
            </AreaVideo>
          </div>
        </Swiper>
        <Swiper {...thumbnailSwiperParams}>
          <div className="swiper-slide">
            <div className="icon-play">
              <img src={IconePlay} alt="Icone play" />
            </div>
            <img src={`https://i.ytimg.com/vi/qx5hPRUdK3I/hqdefault.jpg`} alt="Icone convenção Inovafarma 2019" />
          </div>
          <div className="swiper-slide">
            <div className="icon-play">
              <img src={IconePlay} alt="Icone play" />
            </div>
            <img src={`https://i.ytimg.com/vi/w5Bm3Cb1Cb8/hqdefault.jpg`} alt="Icone convenção Inovafarma 2018" />
          </div>
          <div className="swiper-slide">
            <div className="icon-play">
              <img src={IconePlay} alt="Icone play" />
            </div>
            <img src={`https://i.ytimg.com/vi/y-FsYAKEfmQ/hqdefault.jpg`} alt="Icone convenção Inovafarma 2017" />
          </div>
          <div className="swiper-slide">
            <div className="icon-play">
              <img src={IconePlay} alt="Icone play" />
            </div>
            <img src={`https://i.ytimg.com/vi/C6P8en0GQZA/hqdefault.jpg`} alt="Icone convenção Inovafarma 2016" />
          </div>
        </Swiper>
      </div>
      <div className="ctrl-slide">
        <div className="btns">
          <button onClick={goPrev} className="btn btn-prev">
            <img src={ArrowPrev} alt="Icone seta voltar" />
          </button>
          <button onClick={goNext} className="btn btn-next">
            <img src={ArrowNext} alt="Icone seta avançar" />
          </button>
        </div>
        <div className="swiper-pagination"></div>
      </div>
    </div>
  )
}

export default Gallery
